import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Badge } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { ResourceManager } from '../../../core/resource-manager';
import courseDefault from '../../../assets/course.jpg';
import moment from 'moment';




export default function CardCorsoList({ data }) {

    const navigate = useNavigate();
    const [errors, setErrors] = useState(null);
    const [image, setImage] = useState(null);


    useEffect(() => {
        console.log('data-card-v2', data)
        var image = {
            hash: data.hash,
            extension: data.extension
        }
        setImage(image ? ResourceManager.getFileUrl(image, data.entity) : courseDefault)

    }, [data]);

    function clickAction() {
        navigate('/corsi/' + data.id)
    }


    if (data) {
        return (
            <Card role="button" onClick={clickAction} className='my-3 text-dark h-100' style={{ borderRadius: '20px' }}>
                <Card.Img className='image-hover' variant="top" src={image} style={{ borderStartEndRadius: '20px', borderStartStartRadius: '20px' }} />
                <Card.Body>
                    <Card.Text>
                        <small>Corsi | {data && data.category}</small>
                    </Card.Text>
                    <Card.Text style={{ minHeight: '70px' }}>
                        <h5>{data && data.name}</h5>
                    </Card.Text>
                    <Card.Text>
                        <Badge bg={data.public === 1 ? 'success' : 'warning'} pill className='me-2 mb-2'><small>{data && data.public === 1 ? 'Pubblicato' : 'In arrivo'}</small></Badge>
                        {data.date_end && moment(data.date_end).isBefore(moment()) && (
                            <Badge bg='danger' pill className='me-2 mb-2'>
                                <small>Terminato</small>
                            </Badge>
                        )}
                        <Badge bg='light' pill className='text-black me-2'><small>{data && data.episodes ? data.episodes : 0} lezioni</small></Badge>
                        <Badge bg='light' pill className='text-black me-2'>
                            <small>{data.estimatedTime ? data.estimatedTime : 0} ore</small>
                        </Badge>
                        <Badge bg='light' pill className='text-black me-2'>
                            <small>Inizio il: {data.date_start && moment(data.date_start).format('DD-MM-YYYY')}</small>
                        </Badge>
                        <Badge bg='light' pill className='text-black me-2'>
                            <small>Fine il: {data.date_end && moment(data.date_end).format('DD-MM-YYYY')}</small>
                        </Badge>
                        
                    </Card.Text>
                </Card.Body>
            </Card>
        );
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }

};